import React from 'react';
import { Button } from '@cjdev-internal/visual-stack-x/components/Button';

export const SubmitButtonWrapper = ({ loading, children, ...rest }) => (
  <Button htmlType='submit' spinner={loading} type="primary" {...rest}>
    {children}
  </Button>
);
